import React, {Component, useState} from 'react';
import Select from 'react-select';
import {
    Alert,
    Button,
    Col,
    ControlLabel,
    Form,
    FormControl,
    FormGroup,
    ListGroup,
    ListGroupItem,
    Modal,
    Row
} from 'react-bootstrap';
import {SketchPicker} from 'react-color';
import {connect} from 'react-redux';
import InfinteScroll from "react-infinite-scroll-component";
import Slider from "react-slick";
import DesignFontsPanel from '../../components/FontsPanel';

import {fetch_user_details} from '../../components/loginModal/actions';
import {
    fetch_color_palettes,
    fetch_display_color_palettes,
    fetch_teams,
    update_brand_data,
    upload_brand_file
} from './actions';
import Colour_Picker from '../../components/Colour_Picker';

import './style.css';


var NextArrow = props => {
    const { className, style, onClick } = props;
    return (
        <div
            className="slick-arrow slick-next"
            // style={{ ...style, display: "block", background: "red" }}
            onClick={onClick}
        >
            <i style={{'width': '20px', 'height': '20px', 'color': '#333333'}} className="fas fa-lg fa-angle-right"></i>
        </div>
    );
}
  

var PrevArrow = props => {
    const { className, style, onClick } = props;
    return (
        <div
            className="slick-arrow slick-prev"
            // style={{ ...style, display: "block", background: "red" }}
            onClick={onClick}
        >
            <i style={{'width': '20px', 'height': '20px', 'color': '#333333'}} className="fas fa-lg fa-angle-left"></i>
        </div>
    );
}


const slider_settings = {
    slidesToShow: 1,
    slidesToScroll : 5,
    variableWidth: true,
    infinite: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
};

const bk_button_style = {
    color: '#A5759E',
    fontSize: 14,
    cursor: 'pointer',
}

class BrandKit extends Component {
    

    constructor(props) {
        super(props);
        this.state = {
            own_teams : [],
            member_teams : [],
            selected_team: null,
            selected_brand_kit: null,
            show_modal_upload_file: false,
            show_modal_swatches: false,
            upload_type: null,
            show_modal_font_style: false,
            show_color_picker: false,
            font_type: null,
            current_color: {'hex': '#ffffff'},
            page: 1,
            limit: 60,
            active_color_category: null,
            color_palettes: [],
            has_more_cp: true,
            show_new_color_palette_modal: false,
            show_confirmation_modal: false,
            deletion_element: null,
            deletion_index: null,
            show_font_selection_modal: false,
        }
    }

    componentDidMount() {
        console.log("history", this.props)
        this.fetch_teams(); 
        this.props.fetch_display_color_palettes()
        .then(data => {
            var display_color_palettes = data.color_palettes;
            var color_palette_categories = data.category_data;
            this.setState({display_color_palettes, color_palette_categories});
        })    
    }

    fetch_teams = () => {
        this.props.fetch_teams()
        .then(user_details => {
            var selected_team =  user_details.own_teams[0];
            var selected_brand_kit =  user_details.own_teams[0].brand_kits[0];
            selected_brand_kit = { all_fonts: [ ...selected_brand_kit.selected_fonts.map( x => ({ ...x, type: 'design_resource' }) ), ...selected_team.font_uploads.map( x => ({ ...x, type: 'user_upload' }) ) ], ...selected_brand_kit };
            this.setState({selected_team, selected_brand_kit, own_teams: user_details.own_teams, member_teams: user_details.member_teams});
            selected_brand_kit.all_fonts.map(x => {
                var custom_font = new FontFace(x.name, 'url('+ global.config.server_path + x.src +')');
                custom_font.load().then(function(loaded_face) {
                    document.fonts.add(loaded_face);
                    document.body.style.fontFamily = '"' + x.name + '", Arial';
                }).catch(function(error) {
                    // error occurred
                    console.log(error);
                });
            })
            
            var font_options = selected_team.font_uploads.map(x => ({value: x.name, label: x.name, font_src: x.src}));
            this.setState({font_options});
        })
        .catch(err => Promise.reject(err))
    }

    fetch_color_palettes = async category => {
        if (category) {
            this.setState({active_color_category: category})        
        } else {
            category = this.state.active_color_category;
        }
        var color_palettes = await this.props.fetch_color_palettes(category, this.state.limit, this.state.page);
        if (color_palettes.length) {
            this.setState({color_palettes: [...this.state.color_palettes, ...color_palettes]});
        } else {
            this.setState({has_more_cp: false})
        }
    }

    hide_confirmation_modal = () => this.setState({ show_confirmation_modal: false, deletion_element: null, deletion_index: null });
    

    hide_font_selection_modal = () => this.setState({ show_font_selection_modal: false });


    delete_element_with_confirmation = ({ deletion_element, deletion_index }) => {
        this.setState({ show_confirmation_modal: true, deletion_element, deletion_index });
    }

    show_swatches_modal = () => this.setState({active_color_category: null, color_palettes: [], show_modal_swatches: true});

    ConfirmationModal = ({ show_confirmation_modal, hide_confirmation_modal, deletion_element, deletion_index }) => {
        var success = () => {
            hide_confirmation_modal();
            console.log(deletion_element, deletion_index);
            this.delete_bk_element();
        }

        var failure = () => {
            hide_confirmation_modal();
        }

        return (
            <Modal show={show_confirmation_modal} onHide={hide_confirmation_modal}>
                <Modal.Header closeButton>
                    <Modal.Title style={{fontFamily: 'Montserrat', fontWeight: 800}}>Delete {deletion_element}</Modal.Title>
                </Modal.Header>
                <Form horizontal >
                    <Modal.Body>
                        <span style={{fontFamily: 'Montserrat'}}> Are you sure want to delete this {deletion_element} ?</span>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn-orange-inverse" onClick={failure}>No</Button>
                        <Button className="btn-orange-inverse" onClick={success}>Yes</Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        );
    }

    FontSelectionModal = ({ show_font_selection_modal, hide_font_selection_modal, update_brand_data, fetch_teams }) => {
        const select_font = args => {
            try {

            } catch(err) {
                console.log(err);
            }
        }

        const set_selected_font = async ({ value, name, _id }) => {
            var brand_kit = JSON.parse(JSON.stringify(this.state.selected_brand_kit));
            brand_kit.selected_fonts = [ _id, ...brand_kit.selected_fonts.map(x => x._id) ];
            var data = await update_brand_data(brand_kit)
            console.log(data);
            await fetch_teams();
            hide_font_selection_modal();
        }

        return (
            <Modal show={show_font_selection_modal} onHide={hide_font_selection_modal}>
                <Modal.Header closeButton>
                    <Modal.Title style={{fontFamily: 'Montserrat', fontWeight: 800}}>Choose Fonts</Modal.Title>
                </Modal.Header>
                <Form horizontal >
                    <Modal.Body>
                        <DesignFontsPanel
                            external_height = "250px"
                            update_inputs_text = {set_selected_font}
                        /> 
                    </Modal.Body>
                </Form>
            </Modal>
        );
    } 


    FontsPanel = () => {
        if (this.props.user && this.state.selected_team)  {
            var styles = {
                heading: {
                    fontFamily: this.state.selected_brand_kit.fonts.heading.name,
                    fontSize: this.state.selected_brand_kit.fonts.heading.size + "px"
                },
                sub_heading: {
                    fontFamily: this.state.selected_brand_kit.fonts.sub_heading.name,
                    fontSize: this.state.selected_brand_kit.fonts.sub_heading.size + "px"
                },
                paragraph: {
                    fontFamily: this.state.selected_brand_kit.fonts.paragraph.name,
                    fontSize: this.state.selected_brand_kit.fonts.paragraph.size + "px"
                },

            }
            return (
                <table>
                    <tbody>
                        <tr style={{...styles.heading, verticalAlign: 'top'}}>
                            <td>
                                <div > Headings are {this.state.selected_team.brand_kits[0].fonts.heading.name}, size {this.state.selected_team.brand_kits[0].fonts.heading.size}</div>
                            </td>
                            <td>
                                <div onClick={(e) => this.open_modal_font_style('heading')} className="btn btn-orange btn-circle"><span className="fas fa-edit" /></div>
                            </td>
                        </tr>
                        <hr />
                        <tr style={{...styles.sub_heading, verticalAlign: 'top'}}>
                            <td>
                                <div> Sub headings are {this.state.selected_team.brand_kits[0].fonts.sub_heading.name}, size {this.state.selected_team.brand_kits[0].fonts.sub_heading.size}</div>
                            </td>
                            <td>
                                <div onClick={(e) => this.open_modal_font_style('sub_heading')} className="btn btn-orange btn-circle"><span className="fas fa-edit" /></div>
                            </td>
                        </tr>
                        <hr />
                        <tr style={{...styles.paragraph, verticalAlign: 'top'}}>
                            <td>
                                <div> Normal text are {this.state.selected_team.brand_kits[0].fonts.paragraph.name}, size {this.state.selected_team.brand_kits[0].fonts.sub_heading.size}. This is a sample paragraph. Text looks like this. The quick brown fox jumps over a lazy dog.</div>
                            </td>
                            <td>
                                <div onClick={(e) => this.open_modal_font_style('paragraph')} className="btn btn-orange btn-circle"><span className="fas fa-edit" /></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            ) 
        } else {
            return (<><h1><br/><br/></h1><h2><br/><br/></h2><p><br/><br/></p></>)
        }
    }

    CustomFontsPanel = () => (
        <ListGroup>
            <Button style={{borderRadius: 0}}  className="btn-block btn-orange"><span className="fas fa-plus fa-lg"></span> &nbsp;  <b>Upload New Font</b></Button>
            {this.state.selected_team && this.state.selected_team.font_uploads.map(font => (
                <ListGroupItem><span style={{fontFamily: font.name}}>{font.name}</span> </ListGroupItem>
            ))}
        </ListGroup>
    )

    FontPanel = () => (this.props.user && this.state.selected_team && this.state.selected_brand_kit.all_fonts.length && this.state.selected_brand_kit.all_fonts[0]) ? (
        <Row style={{ marginTop: 10, marginBottom: 10 }}>
            <div style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Slider className="brandkit-horizontal-scroll-component" className="slick_shadow" {...slider_settings}>
                    {this.state.selected_brand_kit && this.state.selected_brand_kit.all_fonts.map( ( font, index ) => (
                        <this.FontBox className="template_slide_container_bk" font={font} index={index} />
                    ))}
                </Slider>
            </div>
        </Row>
    ) : ('No fonts selected')
    
    FontBox = ({ font, index }) => {
        const container_style = {
            height: 150, 
            width: 150,
            border: '1px solid #C8CDD4',
            borderRadius: 6,
            marginBottom: 10, 
            marginRight: 10
        };
        const inner_style = {
            padding: 7,
            fontFamily: font.name,
            fontSize: 28,
            whiteSpace: 'nowrap',
            height: 150,
            width: 150,
            maxWidth: 150,
            display: 'table-cell',
            verticalAlign: 'middle',
            textAlign: 'center',
            overflow: 'hidden',
            textOverflow: 'ellipsis' 
        }
        return (
            <div className="template_slide_container_bk" key={'horizonal-scroll-tempates'+index} style={container_style} >
                <div style={inner_style} >
                    {font.name}
                </div>
                <div className="btn btn-circle btn-orange btn-xs" onClick={() => this.delete_element_with_confirmation({ deletion_element: 'font_' + font.type, deletion_index: index })} style= {{display: "block", float:"right", position:"absolute", top:-5, right: -10, borderRadius: "50%"}}><span style={{padding:1}} className="fas fa-times" /> </div>
            </div>
        )
    }


    update_color = (color, event) => {
        this.setState({current_color: color});
        console.log(color); 
    }

    update_all_colors = () => {
        var brand_kit = JSON.parse(JSON.stringify(this.state.selected_brand_kit));
        if (brand_kit.color_palette && brand_kit.color_palette.length) {
            brand_kit.color_palette[0].colors.push(this.state.current_color.hex);
        } else {
            brand_kit.color_palette = [{colors: [this.state.current_color.hex]}];
        }
        this.props.update_brand_data(brand_kit)
        .then(data => {
            console.log(data);
            this.fetch_teams();
        })
        .catch(err => console.log(err))
        console.log('final bk -><><><><><-', brand_kit);
        this.setState({show_color_picker: null})
    }

    set_colors = color_palette => {
        var brand_kit = JSON.parse(JSON.stringify(this.state.selected_brand_kit));
        brand_kit.color_palette = [...brand_kit.color_palette, color_palette];
        this.props.update_brand_data(brand_kit)
        .then(data => {
            console.log(data);
            this.fetch_teams();
        })
        .catch(err => console.log(err))
        console.log('final bk -><><><><><-', brand_kit);
        this.setState({show_modal_swatches: null})
    }

    delete_bk_element = async () => {
        try {
            var brand_kit = JSON.parse(JSON.stringify(this.state.selected_brand_kit));
            var { deletion_element, deletion_index } = this.state;

            if (deletion_element == "logo") {
                brand_kit.logos.splice(deletion_index, 1);    
            } else if (deletion_element == 'color_palette') {
                brand_kit.color_palette.splice(deletion_index, 1);    
            } else if (deletion_element == 'font_design_resource') {
                var elem = brand_kit.all_fonts[deletion_index];
                brand_kit.selected_fonts = brand_kit.selected_fonts.filter(x => x._id != elem._id); 
            } else if (deletion_element == 'font_user_upload') {
                var elem = brand_kit.all_fonts[deletion_index];
                var team = JSON.parse(JSON.stringify(this.state.selected_team));
                console.log('updating team data')
                team.font_uploads = team.font_uploads.filter(x => x._id != elem._id); 
                return this.update_font_uploads({ team_id: team._id, font_uploads: team.font_uploads })
            }
            var data = await this.props.update_brand_data(brand_kit)
            console.log(data);
            this.fetch_teams();
        } catch(err) {
            console.log(err);
        }
    }

    update_font_uploads = async ({ team_id, font_uploads }) => {
        try {
            console.log(team_id, font_uploads);
            var url = global.config.server_path + 'user/update_font_uploads';
            var resp = await fetch(url, { method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({ team_id, font_uploads }) });
            resp = await resp.json();
            this.fetch_teams();
        } catch(err) {
            console.log(err);
        }
    }

    delete_element = (type, index) => {
        console.log(type, index)
        var brand_kit = JSON.parse(JSON.stringify(this.state.selected_brand_kit));
        if (type == "logo") {
            brand_kit.logos.splice(index, 1);    
        } else if (type == 'color') {
            brand_kit.color_palette[0].colors.splice(index, 1);
        }
        this.props.update_brand_data(brand_kit)
        .then(data => {
            console.log(data);
            this.fetch_teams();
        })
        .catch(err => console.log(err))
        console.log('final bk -><><><><><-', brand_kit);
    }

    hideColorPicker = () => {
        this.setState({ show_color_picker : false })
    };

    showColorPicker = ({ target }) => {
        this.setState({ show_color_picker : true, target })
    };

    hide_new_color_palette_modal = () => this.setState({ show_new_color_palette_modal: false })

    color_picker = ({ on_change }) => {
        const [selected_color, set_selected_color] = useState('#fff');

        const styles = {
            popover: {
                position: 'absolute',
                zIndex: '2',
                // right : this.state.selected_brand_kit.color_palette.length*100 + 'px'
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
                zIndex: '-1'
            },
        }
        return (
            <div>
                { this.state.show_color_picker ? <div style={ styles.popover }>
                <div style={ styles.cover } onClick={() => {this.hideColorPicker(); on_change(selected_color);}}/>
                <Colour_Picker user={this.props.user}  color={selected_color} onChange={color => set_selected_color(color.hex)} target={this.state.target} presetColors={['#ffffff','#f3ec3a','#f9bd17','#f99b1d','#f15523','#ef3124','#DE0081','#a71e48','#7c3597','#463191','#000000','#3d5dac','#1296ce','#63b145','#19BC81','#d0dd36']} />                
                </div> : null 
                }
            </div>
        )
    }


    UploadContainer = props => (
        <div key={props.index} style={{marginBottom: 10, marginRight: 10, display:'inline-block', backgroundColor: props.color, position: "relative"}} className="img-thumbnail">
            <img style={{height: 100, width: 100}} src={props.src?props.src:'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='}></img>
            <div className="btn btn-circle btn-orange btn-xs" onClick={() => props.type == 'color' ? props.delete_color(props.index) : this.delete_element(props.type, props.index)} style= {{display: "block", float:"right", position:"absolute", top:-10, right: -10, borderRadius: "50%"}}><span style={{padding:1}} className="fas fa-times" /> </div>
        </div>
    )


    AddButton = props => (
        <div id="add_button" style={{verticalAlign: 'middle', display: 'inline-block'}} onClick={props.onClick} className="img-thumbnail"><span style={{padding: 16}} className="fas fa-light fa-plus fa-5x centered_icon"/></div>
    ) 


    LogoPanel = () => (this.props.user && this.state.selected_team) ? (
        <>  
            <Row style={{ marginTop: 10, marginBottom: 10 }}>
                <div style={{ paddingLeft: 5, paddingRight: 5 }}>
                    <Slider className="brandkit-horizontal-scroll-component" className="slick_shadow" {...slider_settings}>
                        {this.state.selected_team.brand_kits[0].logos.map((logo, index) => (
                            <this.LogoBox className="template_slide_container_bk" src={global.config.server_path + logo.src} type="logo" index={index} />
                        ))}                                
                    </Slider>
                </div>
            </Row>   
        </> 
    ) : (<></>)

    LogoBox = props => (
        <div key={props.index} style={{ marginBottom: 10, marginRight: 10, display:'inline-block', position: "relative", padding: 0, borderRadius: 6}} className="img-thumbnail checkered_bg">
            <img style={{height: 150, width: 150, borderRadius: 6, objectFit: 'contain'}} src={props.src?props.src:'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='}></img>
            <div className="btn btn-circle btn-orange btn-xs" onClick={() => this.delete_element_with_confirmation({ deletion_element: 'logo', deletion_index: props.index })} style= {{display: "block", float:"right", position:"absolute", top:-5, right: -10, borderRadius: "50%"}}><span style={{padding:1}} className="fas fa-times" /> </div>
        </div>
    )

    NewColorPaletteModal = ({ UploadContainer, show_new_color_palette_modal, hide_new_color_palette_modal, showColorPicker, set_colors, show_swatches_modal }) => {
        const [selected_colors, set_selected_colors] = useState([]);
        const [name, set_name] = useState('');
        const [show_error, set_show_error] = useState(false);
        const [error_message, set_error_message] = useState();

        const add_color = color => {
            console.log('color received', color);
            selected_colors.push(color)
        }

        const AddButtonColor = props => (
            <div style={{'display': 'inline-block'}}><div id="add_button" style={{verticalAlign: 'middle', display: 'inline-block'}} onClick={props.onClick} className="img-thumbnail"><span style={{padding: 16}} className="fas fa-light fa-plus fa-5x centered_icon"/></div><this.color_picker on_change={add_color}/></div>
        ) 

        const delete_color = index => {
            console.log(index)
            set_selected_colors([...selected_colors.filter(x => selected_colors.indexOf(x) != index)]);
        }

        const create_new_palette = async () => {
            if (selected_colors.length == 5 && name) {
                set_show_error(false);
                set_error_message();
                await set_colors({ name, colors: selected_colors });
                hide_new_color_palette_modal();
                set_name('');
                set_selected_colors([]);
                set_show_error(false);
            } else {
                set_show_error(true);
                set_error_message('You must add 5 colors and set a name');

            }
        }

        const choose_other = () => {
            hide_new_color_palette_modal();
            show_swatches_modal();
        }

        // useEffect( () => {
        //     set_name('');
        //     set_selected_colors([]);
        //     set_show_error(false);            
        // }, [ show_new_color_palette_modal ])

        return (

            <Modal show={show_new_color_palette_modal} onHide={hide_new_color_palette_modal} bsSize="large" >
                <Modal.Header closeButton>
                    <Modal.Title style={{fontFamily: 'Montserrat', fontWeight: 800}}>Add New Color Palette</Modal.Title>
                </Modal.Header>
                <Form horizontal>
                    <Modal.Body>
                        <Row className="text-center">
                            <Button className="btn-orange" style={{ fontFamily: 'Montserrat'}} onClick={choose_other} > Choose from existing palettes</Button>                            
                        </Row>
                        <hr />
                        <FormGroup controlId="formHorizontalName">
                            <Col style={{fontFamily: 'Montserrat'}} componentClass={ControlLabel} sm={3}>
                                Name
                            </Col>
                            <Col sm={6}>
                                <FormControl style={{fontFamily: 'Montserrat'}} required value={name} type="text" onChange={e => set_name(e.target.value)} name="name" placeholder="Name" />
                            </Col>
                        </FormGroup>
                        <Row className="text-center">
                            {selected_colors.map((color, index) => (
                                <UploadContainer color={color} index={index} delete_color={delete_color} type="color" />
                            ))}
                            {(selected_colors.length < 5) && (<AddButtonColor onClick={({target}) => showColorPicker({target})} />)}
                            <br />
                            <Row>
                                
                            </Row>
                            {show_error && (<Alert style={{fontFamily: 'Montserrat'}} bsStyle="danger"><strong>{error_message}</strong></Alert>)}
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn-orange" style={{fontFamily: 'Montserrat'}} onClick={create_new_palette}> Create color palette </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        );
    } 

    ColorPanel = () => (this.props.user && this.state.selected_team && this.state.selected_brand_kit.color_palette.length && this.state.selected_brand_kit.color_palette[0]) ? (
        <Row style={{ marginTop: 10, marginBottom: 10 }}>
            <div style={{ paddingLeft: 5, paddingRight: 5 }}>
                <Slider className="brandkit-horizontal-scroll-component" className="slick_shadow" {...slider_settings}>
                    {this.state.selected_brand_kit.color_palette.map( ( palette, index ) => (
                        <this.ColorPanelBox className="template_slide_container_bk" colors={palette.colors} index={index} />
                    ))}                                
                </Slider>
            </div>
        </Row>
    ) : ('No color palettes added')
    
    ColorPanelBox = ({ colors, index }) => {
        const container_style = {
            height: 150,
            width: 150,
            borderRadius: 9,
            marginBottom: 10, 
            marginRight: 10
        }
        const inner_style = (color, index) => ({
            height: 30, 
            width: 150, 
            backgroundColor: color,
            borderRadius: [0, colors.length - 1].includes(index) ? (index == 0 ? '6px 6px 0px 0px' : '0px 0px 6px 6px') : 0
        })
        return (
            <div className="template_slide_container_bk" key={'horizonal-scroll-tempates'+index} style={container_style} >
                {colors.map( ( color, index ) => (
                    <div style={inner_style(color, index)} />
                ))}
                <div className="btn btn-circle btn-orange btn-xs" onClick={() => this.delete_element_with_confirmation({ deletion_element: 'color_palette', deletion_index: index })} style= {{display: "block", float:"right", position:"absolute", top:-5, right: -10, borderRadius: "50%"}}><span style={{padding:1}} className="fas fa-times" /> </div>
            </div>
        )
    }

    upload_font = e => {
        e.preventDefault();
        console.log(this.state.name, this.state.file);
        this.props.upload_brand_file(this.state.name, this.state.upload_type, this.state.file)
        .then(data => {
            console.log(data);
            this.fetch_teams();
        })
        .catch(err => console.log(err))
        this.setState({show_modal_upload_file: false, upload_type: null, name: null, file: null});
    }

    customize_font = e => {
        e.preventDefault();
        console.log(this.state.size);
        var brand_kit = JSON.parse(JSON.stringify(this.state.selected_brand_kit));
        brand_kit.fonts[this.state.font_type] = {
            size: this.state.size,
            src: this.state.selected_font_src,
            name: this.state.selected_font_name,
        };
        this.props.update_brand_data(brand_kit)
        .then(data => {
            console.log(data);
            this.fetch_teams();
        })
        .catch(err => console.log(err))
        console.log('final bk -><><><><><-', brand_kit);
        this.setState({
            font_type: null, 
            show_modal_font_style: null,
            size: null,
            selected_font_name: null,
            selected_font_src: null
        })
    }

    update_uploads = (event) => {
        this.setState({[event.target.name]: event.target.files[0]})
    }

    update_inputs = (event) => {
        this.setState({[event.target.name]: event.target.value});
    }

    open_modal_font_style = font_type => {
        this.setState({
            font_type, 
            show_modal_font_style: true, 
            size: this.state.selected_brand_kit.fonts[font_type].size, 
            selected_font_name: this.state.selected_brand_kit.fonts[font_type].name, 
            selected_font_src: this.state.selected_brand_kit.fonts[font_type].src
        })
    }

    apply_font = e => {
        console.log(e, e.value);
        this.setState({selected_font_name: e.value, selected_font_src: e.font_src});
    }

    render() {
        const font_styles = {
            control: styles => ({ ...styles, backgroundColor: 'white' }),
            option: (styles, { data, isDisabled, isFocused, isSelected }) => {
              return {
                ...styles,
                fontFamily : data.label,
              };
            },
            singleValue: (provided, state) => {
                const opacity = state.isDisabled ? 0.5 : 1;
                const transition = 'opacity 300ms';
            
                return { ...provided, opacity, transition };
            }
        };

        const overlay_div = (
            <div className="centeredOverlay"> <span className="" /> <span><h3 style={{color:'#ffffff'}}>Login/Sign upto create your own brand kit.</h3></span></div>
        )

        const user_upload_modal = (
            <Modal show={this.state.show_modal_upload_file} onHide={() => this.setState({show_modal_upload_file: false, upload_type: null})}>
                <Modal.Header closeButton>
                    <Modal.Title style={{fontFamily: 'Montserrat', fontWeight: 800}}>Add New {this.state.upload_type == 'font' ? "Custom Font" : "Logo"}</Modal.Title>
                </Modal.Header>
                <Form horizontal onSubmit={this.upload_font}>
                    <Modal.Body>
                        {this.state.upload_type == 'font' ? (
                            <>
                                <Row className="text-center">
                                    <Button className="btn-orange" style={{ fontFamily: 'Montserrat'}} onClick={ () => this.setState({ show_font_selection_modal: true, show_modal_upload_file: false, upload_type: null }) } > Choose from existing palettes</Button>                            
                                </Row>
                                <hr />
                            </>
                        ) : (<></>)}
                        <FormGroup controlId="formHorizontalName">
                            <Col style={{fontFamily: 'Montserrat'}} componentClass={ControlLabel} sm={3}>
                                Name
                            </Col>
                            <Col sm={9}>
                                <FormControl style={{fontFamily: 'Montserrat'}} required value={this.state.name ? this.state.name : ''} type="text" onChange={event => this.update_inputs(event)} name="name" placeholder="Name" />
                            </Col>
                        </FormGroup>
                        
                        <FormGroup controlId="formHorizontalImage">
                            <Col componentClass={ControlLabel} sm={3} style={{fontFamily: 'Montserrat'}}>
                                Upload File
                            </Col>
                            <Col sm={9}>
                                <FormControl required type="file" style={{"marginTop": "0.7rem", fontFamily: 'Montserrat'}} onChange={event => this.update_uploads(event)} name="file" />
                            </Col>
                        </FormGroup>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="submit" className="btn-orange" style={{fontFamily: 'Montserrat'}}>Upload {this.state.upload_type == 'font' ? "Custom Font" : "Logo"}</Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        )

        const font_selection_modal = (
            <Modal show={this.state.show_modal_font_style} onHide={() => this.setState({show_modal_font_style: false, font_type: null})}>
                <Modal.Header closeButton>
                    <Modal.Title style={{fontFamily: 'Montserrat', fontWeight: 800}}>Customize {this.state.font_type == 'sub_heading' ? "sub heading" : this.state.font_type} font</Modal.Title>
                </Modal.Header>
                <Form horizontal onSubmit={this.customize_font}>
                    <Modal.Body>
                        <FormGroup controlId="formHorizontalName">
                            <Col componentClass={ControlLabel} style={{fontFamily: 'Montserrat'}} sm={3}>
                                Font Size (in px)
                            </Col>
                            <Col sm={9}>
                                <FormControl required value={this.state.size ? this.state.size : null} style={{fontFamily: 'Montserrat'}} onChange={event => this.update_inputs(event)} type="number"  name="size" placeholder="Font Size" />
                            </Col>
                        </FormGroup>
                        
                        <FormGroup controlId="formHorizontalFont">
                            <Col componentClass={ControlLabel} sm={3} style={{fontFamily: 'Montserrat'}}>
                                Select Font
                            </Col>
                            <Col sm={9}>
                                <Select label="Single select" 
                                    value={this.state.selected_font_name ? {value: this.state.selected_font_name, label: this.state.selected_font_name, font_src: this.state.selected_font_src} : null} 
                                    options={[{label:'Cutom Fonts', options: this.state.font_options}]} 
                                    styles={font_styles} 
                                    placeholder="Choose Font" 
                                    onChange={(e) => this.apply_font(e)}
                                />
                            </Col>
                        </FormGroup>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button style={{fontFamily: 'Montserrat'}} type="submit" className="btn-orange">Change {this.state.font_type == 'sub_heading' ? "sub heading" : this.state.font_type} style</Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        )


        const swatches_modal = (
            <Modal show={this.state.show_modal_swatches} onHide={() => this.setState({show_modal_swatches: false})}>
                <Modal.Header closeButton>
                    <Modal.Title style={{fontFamily: 'Montserrat', fontWeight: 800}}>Choose color palette {this.state.active_color_category ? '- ' + this.state.color_palette_categories[this.state.active_color_category].name : ''}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{maxHeight: "60vh", overflowY: "auto"}}>
                    {this.state.active_color_category ? (
                        <>
                            <Row><span style={{fontFamily: 'Montserrat', fontSize: 14, cursor: 'pointer'}} className="btn-secondary btn-xs" onClick={() => this.setState({color_palettes: [], active_color_category: null})}><span className="fa fa-arraow-left"/> &nbsp;Back</span></Row>
                            <br />
                            <InfinteScroll
                                dataLength={this.state.color_palettes.length}
                                next= {this.fetch_color_palettes}
                                hasMore={this.state.has_more_cp}
                                endMessage={<h4>No more results.</h4>} 
                                height={500}
                            >
                                <Row style={{height: '100%'}}>
                                    {this.state.color_palettes && this.state.color_palettes.map(cp => (
                                        <Col style={{padding: 2, height: 47}} xs={6} className="swatch_container" onClick={() => this.set_colors(cp)}>
                                            {cp.colors.map(x => (
                                                <Col className="color_container" style={{padding: 0, marginLeft: 4, marginBottom: 10}} xs={2}><div  style={{padding:1,height: 35, backgroundColor:  x}}></div></Col>
                                            ))}
                                        </Col>
                                    ))}
                                </Row>
                            </InfinteScroll>
                        </>
                    ) : (
                        <ListGroup>
                            {this.state.display_color_palettes && Object.keys(this.state.display_color_palettes).map(category => (
                                <>
                                    <ListGroupItem style={{fontFamily: 'Montserrat', fontSize: 14, backgroundColor: '#F1F2F3', paddingLeft: 4, paddingRight: 4, paddingTop: 6, paddingBottom: 6}} >
                                        {this.state.color_palette_categories[category].name} <span style={{fontFamily: 'Montserrat', fontSize: 14, cursor: 'pointer'}} onClick={() => this.fetch_color_palettes(category)} className="btn-secondary btn-xs pull-right">See All</span>
                                    </ListGroupItem>
                                    <ListGroupItem style={{marginBottom: 10, paddingLeft: 4, paddingRight: 4, paddingTop: 6, paddingBottom: 6}}>
                                        <Row>
                                            {this.state.display_color_palettes[category] && this.state.display_color_palettes[category].length && this.state.display_color_palettes[category].map(cp => (
                                                <Col style={{padding: 2, height: 47}} xs={6} className="swatch_container" onClick={() => this.set_colors(cp)}>
                                                    {cp.colors.map(x => (
                                                        <Col className="color_container" style={{padding: 0, marginLeft: 4, marginBottom: 10}} xs={2}><div  style={{padding:1,height: 35, backgroundColor:  x}}></div></Col>
                                                    ))}
                                                </Col>
                                            ))}  
                                        </Row>
                                    </ListGroupItem>
                                </> 
                            ))}
                        </ListGroup>
                    )}
                </Modal.Body>
            </Modal>
        )

        return (
            <div style={{ marginLeft: '-40px' }}>
                {user_upload_modal}
                {font_selection_modal}
                {swatches_modal}
                <this.NewColorPaletteModal 
                    showColorPicker = {this.showColorPicker} 
                    show_new_color_palette_modal = {this.state.show_new_color_palette_modal} 
                    hide_new_color_palette_modal = {this.hide_new_color_palette_modal}
                    UploadContainer = {this.UploadContainer}
                    set_colors = {this.set_colors}
                    show_swatches_modal = {this.show_swatches_modal}
                />
                <this.FontSelectionModal 
                    show_font_selection_modal = {this.state.show_font_selection_modal} 
                    hide_font_selection_modal = {this.hide_font_selection_modal}
                    update_brand_data = {this.props.update_brand_data}
                    fetch_teams = {this.fetch_teams}
                />
                <this.ConfirmationModal 
                    show_confirmation_modal = {this.state.show_confirmation_modal} 
                    hide_confirmation_modal = {this.hide_confirmation_modal} 
                    deletion_element = {this.state.deletion_element}
                    deletion_index = {this.state.deletion_index}
                />
                {/* <Row id="brand_kit_header"><h2 className="text-left" style={{paddingLeft: 20, color: "white"}}>{this.state.selected_team && this.state.selected_team.name}</h2></Row> */}
                <Row style= {{ backgroundColor:"white", height: 'calc(100vh - 75px)', overflowY: 'scroll'}}>
                    {/*this.props.user ? (<></>) : overlay_div*/ }
                    <br />
                    <br />
                    <Row>
                        <Col style={{paddingLeft: 25, paddingBottom: 25, paddingRight: 25}}>
                            <Row>
                                <h4>
                                    <span style={{ fontWeight: 'bold', fontSize: 24}}>Logos </span>
                                    <span className="pull-right" style={bk_button_style} onClick={(e) => this.setState({show_modal_upload_file: true, upload_type: 'logo'})} > + Add New</span>
                                </h4>
                            </Row>
                            <Row style={{paddingLeft: 35}}>
                                <this.LogoPanel />
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{paddingLeft: 25, paddingBottom: 25, paddingRight: 25}}>
                            <Row>
                                <h4>
                                    <span style={{ fontWeight: 'bold', fontSize: 24}}>Color Palettes </span>
                                    {/* <span className="pull-right" style={bk_button_style} onClick={() => this.setState({active_color_category: null, color_palettes: [], show_modal_swatches: true})}>Choose palette</span> */}
                                    <span className="pull-right" style={bk_button_style} onClick={() => this.setState({show_new_color_palette_modal: true})}> + Add new</span>
                                </h4>
                            </Row>
                            <Row style={{paddingLeft: 35}}>
                                <this.ColorPanel />
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{paddingLeft: 25, paddingBottom: 25, paddingRight: 25}}>
                            <Row>
                                <h4>
                                    <span style={{ fontWeight: 'bold', fontSize: 24}}>Typography</span>
                                    <span className="pull-right" style={bk_button_style} onClick={(e) => this.setState({show_modal_upload_file: true, upload_type: 'font'})}>  + Add new</span>

                                </h4>
                            </Row>
                            <Row style={{paddingLeft: 35}}>
                                <this.FontPanel /> 
                            </Row>
                        </Col>
                    </Row>
                </Row>
            </div>
        )
    }

}

const mapStateToProps = function(state, own_props) {
    return {
        user: state.user,
        ...own_props
    }
}

const mapDispatchToProps = dispatch => ({
    fetch_user_details: dispatch(fetch_user_details()),
    fetch_teams: () => dispatch(fetch_teams()),
    fetch_color_palettes: (category, limit, page) => dispatch(fetch_color_palettes(category, limit, page)),
    update_brand_data: (brand_kit) => dispatch(update_brand_data(brand_kit)),
    fetch_display_color_palettes: () => dispatch(fetch_display_color_palettes()),
    upload_brand_file: (name, file_type, file) => dispatch(upload_brand_file(name, file_type, file)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BrandKit);